import React, { Component, Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import copy from 'copy-to-clipboard';

import { addLinkAction } from 'store/modules/links';
import { toggleTutorialModal } from 'store/modules/modals';

import AlertMessage from 'components/AlertMessage';
import AlertBottomMessage from 'components/AlertBottomMessage';

import FieldSelect from 'components/FieldSelect';
import { reloadIframe } from 'helpers/reloadIframe';
import CounterGroup from 'components/CounterGroup';
import MainInfo from 'components/MainInfo';
import ViewUpgrade from 'components/ViewUpgrade';
import CreatedAllLinks from 'components/CreatedAllLinks';
import PreviewMode from 'components/PreviewMode';
import CreateNew from 'components/CreateNew';
import linkCopy from 'images/link-copy.svg';
import linkGo from 'images/link-go.svg';
import videoSvg from 'images/video-solid.svg';

const DashboardNavigation = ({ id, toggle }) => {
  return (
    <div className="nav-tabs">
      <div className="nav-tabs__inner">
        <NavLink to={`/domain/page/${id}/content`} className="nav-tabs__link">
          Content
        </NavLink>
        <NavLink to={`/domain/page/${id}/styles`} className="nav-tabs__link">
          Styles
        </NavLink>
        <NavLink to={`/domain/page/${id}/analytics`} className="nav-tabs__link">
          Analytics
        </NavLink>
        <div
          className="std-text blue pointer p-l-150 tutorial-help__link"
          onClick={toggle}>
          <span className="icon-outline">
            <img src={videoSvg} alt="acc" />
          </span>
          <span className="link-text">Watch tutorial</span>
        </div>
      </div>
    </div>
  );
};

class Content extends Component {
  static propTypes = {};
  state = {
    showForm: false,
  };

  handleAddLink = async values => {
    const { addLinkAction, match } = this.props;
    const id = match.params.id;
    const params = {
      link: {
        name: values.create_link_name,
        url: values.create_link_url,
        image: values.image,
        variety: values.variety,
      },
    };
    const response = await addLinkAction(id, params);
    if (response.status === 'success') {
      reloadIframe();
    }
  };

  toggleForm = () => {
    this.setState(({ showForm }) => ({
      showForm: !showForm,
    }));
  };

  toggleModal = () => {
    const { toggleTutorialModal } = this.props;
    toggleTutorialModal();
  };

  renderOption = opt => (
    <option key={opt} value={opt}>
      {opt}
    </option>
  );

  render() {
    const { showForm, openModal } = this.state;
    const { account } = this.props;
    const { details } = this.props;
    return (
      <Fragment>
        <AlertBottomMessage content />
        <DashboardNavigation id={account.id} toggle={this.toggleModal} />
        <MainInfo />
        <CreatedAllLinks handleShow={this.toggleForm} showForm={showForm} />
        {showForm && <CreateNew handleSubmit={this.handleAddLink} />}
        {/* <ViewUpgrade
          text="Upgrade to create Image links"
          textBtn="View Plans"
        /> */}
      </Fragment>
    );
  }
}

function mapStateProps(state) {
  return {
    token: state.auth.token,
    account: state.content.account,
    details: state.details.user,
  };
}

const mapDispatchToProps = {
  addLinkAction,
  toggleTutorialModal,
};
export default connect(
  mapStateProps,
  mapDispatchToProps,
)(withRouter(Content));



// WEBPACK FOOTER //
// ./src/scenes/Content/Content.js